/** Server-sent events parser (WHATWG rules): CRLF, CR and LF line ends, multi-line `data`, comments, chunk-split input. */
export interface SseEvent {
	event: string;
	data: string;
}

export class SseParser {
	private buffer = '';
	private event = '';
	private data: string[] = [];
	private hasData = false;
	private skipLf = false;

	/** Feed decoded text; returns the events completed by it. */
	push(text: string): SseEvent[] {
		const out: SseEvent[] = [];
		let chunk = this.buffer + text;
		this.buffer = '';
		if (this.skipLf && chunk.startsWith('\n')) chunk = chunk.slice(1);
		this.skipLf = false;
		let start = 0;
		for (let i = 0; i < chunk.length; i++) {
			const ch = chunk[i];
			if (ch !== '\n' && ch !== '\r') continue;
			this.line(chunk.slice(start, i), out);
			if (ch === '\r') {
				if (chunk[i + 1] === '\n') i++;
				else if (i + 1 === chunk.length) this.skipLf = true;
			}
			start = i + 1;
		}
		this.buffer = chunk.slice(start);
		return out;
	}

	/** Call at end of stream; an event not closed by a blank line is discarded, as the spec says. */
	end(): void {
		this.buffer = '';
		this.data = [];
		this.hasData = false;
		this.event = '';
	}

	private line(line: string, out: SseEvent[]): void {
		if (line === '') {
			if (this.hasData) out.push({ event: this.event || 'message', data: this.data.join('\n') });
			this.event = '';
			this.data = [];
			this.hasData = false;
			return;
		}
		if (line.startsWith(':')) return;
		const colon = line.indexOf(':');
		const field = colon < 0 ? line : line.slice(0, colon);
		let value = colon < 0 ? '' : line.slice(colon + 1);
		if (value.startsWith(' ')) value = value.slice(1);
		if (field === 'event') this.event = value;
		else if (field === 'data') {
			this.data.push(value);
			this.hasData = true;
		}
	}
}
